import { defineComponent as _defineComponent } from 'vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'stock-calendar-cell',
  props: {
    disabled: { type: Boolean },
    selected: { type: Boolean },
    isInView: { type: Boolean },
    day: null,
    data: { default: () => ({
      price: 0,
      count: 0,
      date: "",
    }) }
  },
  emits: ["pick"],
  setup(__props: any, { emit }: { emit: ({
  (name: "pick", value: string): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as { disabled: boolean, selected: boolean, isInView: boolean, day: string | number, data: {
      price: number;
      count: number;
      date: string;
    } }




const onClick = () => {
  if (props.selected || props.data.count <= 0) {
    return;
  }

  emit("pick", props.data.date);
};

return { __sfc: true,props, emit, onClick }
}

})